import { render, staticRenderFns } from "./cova-sync.vue?vue&type=template&id=3d58d150&scoped=true"
import script from "./cova-sync.vue?vue&type=script&lang=js"
export * from "./cova-sync.vue?vue&type=script&lang=js"
import style0 from "./cova-sync.vue?vue&type=style&index=0&id=3d58d150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d58d150",
  null
  
)

export default component.exports